module.exports = __webpack_public_path__ + "img/homepage-banner.70c57c78.jpg";